import _extends from "@babel/runtime/helpers/esm/extends";
import { DATA_GRID_PRO_DEFAULT_SLOTS_COMPONENTS } from '@mui/x-data-grid-pro/internals';
import { GridPremiumColumnMenu } from "../components/GridPremiumColumnMenu.mjs";
import materialSlots from "../material/index.mjs";
import { GridBottomContainer } from "../components/GridBottomContainer.mjs";
import { GridEmptyPivotOverlay } from "../components/GridEmptyPivotOverlay.mjs";
import { GridPremiumToolbar } from "../components/GridPremiumToolbar.mjs";
export const DATA_GRID_PREMIUM_DEFAULT_SLOTS_COMPONENTS = _extends({}, DATA_GRID_PRO_DEFAULT_SLOTS_COMPONENTS, materialSlots, {
  aiAssistantPanel: null,
  chartsPanel: null,
  columnMenu: GridPremiumColumnMenu,
  bottomContainer: GridBottomContainer,
  emptyPivotOverlay: GridEmptyPivotOverlay,
  toolbar: GridPremiumToolbar
});